import React, { useEffect, useState } from "react";
import ConnectedStationsPowerCharts from "./ConnectedStationsPowerCharts";
import dayjs, { Dayjs } from "dayjs";
import ConnectedStationTitle from "./ConnectedStationTitle";

const ConnectedStationsPower = () => {
  const [date] = React.useState<Dayjs | null>(dayjs);

  const [updateKey, setUpdateKey] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => setUpdateKey((x) => x + 1), 1000 * 60);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <ConnectedStationTitle name="Power" />
      <ConnectedStationsPowerCharts date={date} key={updateKey} />
    </>
  );
};

export default ConnectedStationsPower;
